import { Button } from '@ui-kitten/components';
import React, { useCallback, useEffect, useState } from 'react';
import Spinner from 'react-native-loading-spinner-overlay';
import { ErrorModal } from 'src/components/shared/ErrorModal';
import { useIsFocused, useNavigation } from '@react-navigation/native';
import AddActionLayout from 'src/features/actions/AddActionLayout';
import ActiveProtocolList from 'src/features/actions/addProtocol/ActiveProtocolList';
import { useTranslationFunc } from 'src/core/hooks/useTranslationFunc';
import { ProtocolItem } from 'src/core/types/Protocols';
import WebActionItemService from 'src/api/actionItem';
import ActiveProtocolsEmptyList from './ActiveProtocolsEmptyList';

const PROTOCOLS_PER_PAGE = 20;

const ActiveProtocols = () => {
  const transMessage = {
    actionsAdd: 'Add Actions & Protocols'
  };
  const navigation = useNavigation();
  const t = useTranslationFunc(transMessage);
  const IsFocused = useIsFocused();
  const [refreshing, setRefreshing] = useState<boolean>(false);

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [protocols, setProtocols] = useState<ProtocolItem[]>();
  const [errorMessage, setErrorMessage] = useState<any>(null);

  const searchText = '';
  const selectedPillar = 'all';
  const [page, setPage] = useState<number>(1);
  const handleAddActions = () => {
    navigation.navigate('ActionsAdd');
  };

  const fetchActiveProtocolsData = useCallback(() => {
    setIsLoading(true);
    WebActionItemService.getActiveProtocols()
      .then((data: any) => {
        setProtocols(data);
      })
      .catch((error: any) => {
        setIsError(true);
        setErrorMessage(error);
      })
      .finally(() => {
        setIsLoading(false);
        setRefreshing(false);
      });
  }, []);
  useEffect(() => {
    setIsError(false);
    setErrorMessage('');
    if (IsFocused) {
      fetchActiveProtocolsData();
    }
  }, [IsFocused, fetchActiveProtocolsData]);
  useEffect(() => {
    if (refreshing) {
      fetchActiveProtocolsData();
    }
  }, [refreshing, fetchActiveProtocolsData]);
  const onRefresh = useCallback(() => {
    setRefreshing(true);
  }, []);

  useEffect(() => {
    return () => {
      setPage(1);
    };
  }, []);

  if (errorMessage) {
    return (
      <ErrorModal
        visible={true}
        message={errorMessage}
        closeBtnClick={() => {
          navigation.goBack();
        }}
      />
    );
  }
  return (
    <AddActionLayout>
      <Spinner visible={isLoading} />
      {protocols?.length ? (
        <ActiveProtocolList
          refreshing={refreshing}
          onRefresh={onRefresh}
          protocols={(protocols ?? [])
            .filter(
              (protocol) =>
                protocol.status !== 2 && // Ensure status is not 2
                protocol.name.toLocaleLowerCase().match(searchText.toLocaleLowerCase()) &&
                (selectedPillar === 'all'
                  ? true
                  : protocol.actions.some((action: any) => action.action.pillar.toLowerCase() === selectedPillar))
            )
            .slice(0, page * PROTOCOLS_PER_PAGE)}
          handleEndReached={() => setPage((prev) => prev + 1)}
        />
      ) : (
        <ActiveProtocolsEmptyList />
      )}

      <Button
        size="large"
        onPress={handleAddActions}
        style={{
          width: '95%',
          alignSelf: 'center'
        }}
        appearance="outline">
        {t('actionsAdd')}
      </Button>
      <ErrorModal visible={isError} message={errorMessage} />
    </AddActionLayout>
  );
};

export default ActiveProtocols;
